var $ = require('jquery');

function EsvLizenzdaten() {
	$('#all').on('click', function () {
		$('input[name^="korrektur"]').attr('checked', true);
	});
}

module.exports = EsvLizenzdaten;
